<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'
    import type { IWhispererSearch } from '../interfaces/search.interface'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider
    export const onKeyUpProvider = (e: any): void => {
        e = e || window.event as any
        e.preventDefault()
        if (e.keyCode === 38) onArrowUp()
        else if (e.keyCode === 40) onArrowDown()
        else if (e.keyCode === 13) onEnter()
        else if (e.keyCode === 27) onEscape()
    }

    let whispererList: IWhispererSearch[] = []
    let searchString: string = null
    let displayWhisperer = false

    $: isListDisplayed = !!(searchString && displayWhisperer)

    const onEnter = (): void => {
        // eslint-disable-next-line no-prototype-builtins
        if (whispererList.hasOwnProperty(dataProvider.arrowCounter)) {
            const item = whispererList[dataProvider.arrowCounter]
            // eslint-disable-next-line no-undef
            window.location.href = item.url
        }
    }

    const onEscape = (): void => {
        dataProvider.arrowCounter = -1
        serviceProvider.whispererSearchService.searchWhispererSubs = false;
    }

    const onArrowUp = (): void => {
        if (displayWhisperer) {
            if (dataProvider.arrowCounter > -1) {
                dataProvider.arrowCounter = dataProvider.arrowCounter - 1
            }
        }
    }

    const onArrowDown = (): void => {
        if (displayWhisperer) {
            if (dataProvider.arrowCounter < (whispererList.length - 1)) {
                dataProvider.arrowCounter = dataProvider.arrowCounter + 1
            } else {
                dataProvider.arrowCounter = 0
            }
        }
    }

    dataProvider.searchStringSubs.subscribe(
        (search: string | null) => (searchString = search)
    )
    serviceProvider.whispererSearchService.whispererSubs.subscribe(
        (whisperer: IWhispererSearch[]) => {
            dataProvider.arrowCounter = -1
            whispererList = whisperer
        }
    )
    serviceProvider.whispererSearchService.searchWhispererSubs.subscribe(
        (display: boolean) => (displayWhisperer = display)
    )
</script>

<ul class="bno-autocomplete"
    class:u-hide={!isListDisplayed}
    role="listbox"
    id="bno-autocomplete-list-{dataProvider.uniqueId}"
>
    {#if Array.isArray(whispererList) && whispererList.length}
        {#each whispererList as item, i}
            <li class="bno-autocomplete__item"
                role="option"
                class:selected={i === dataProvider.arrowCounter}
                aria-selected={i === dataProvider.arrowCounter}>
                <a href={item.url} class="bno-autocomplete__option" aria-label="{item.title}">
                    <span class="bno-link">{item.title}</span>
                </a>
            </li>
        {/each}
    {:else if dataProvider.noResults}
        <li class="bno-autocomplete__item" aria-selected="false">
            <div class="bno-autocomplete__option">
                <span>{dataProvider.noResults}</span>
            </div>
        </li>
    {/if}
</ul>
